<div
  [ngClass]="{ 'pt-3': showMobileMenu }"
  class="container mx-0 barcode-component w-100 d-block d-lg-none pb-3"
  *ngIf="{
    memberCard: memberCard$ | async,
    barcode: barcode$ | async,
  } as observables"
>
  <ng-container *ngIf="observables.memberCard && observables.barcode; else loadingRef">
    <div class="text-white border-0">
      <ng-container *ngIf="showMobileMenu">
        <fgb-mobile-nav-menu></fgb-mobile-nav-menu>
      </ng-container>
      <div class="modal-body">
        <!--Barcode-->
        <div class="qr glass-bg gloss-white mb-3" *ngIf="isWalletPage">
          <qrcode [qrdata]="observables.barcode.Barcode" [size]="100" [level]="'M'" [usesvg]="true"></qrcode>
          <span class="font-size-12 qr-text mt-1">
            {{ 'qr.scan.text' | translate }}
          </span>
        </div>
        <!--Member Details-->
        <fgb-member-card-details
          [memberDetails]="memberDetails"
          [memberCard]="observables.memberCard"
          cardImage="assets/images/Logos/Redbulls2015Logo.svg"
        ></fgb-member-card-details>
      </div>
    </div>

    <!-- Discount Levels -->
    <div class="my-3" *ngIf="showDiscountLevels">
      <div
        class="d-flex align-items-center justify-content-between text-white mb-2"
        *ngIf="observables.memberCard.RetailDiscountLevel > 0"
      >
        <div class="font-size-14 text-start w-100">{{ 'barcode.fb.discount' | translate }}</div>
        <div class="font-size-14 fw-bold text-end w-100">{{ observables.memberCard.RetailDiscountLevel ?? 0 }}%</div>
      </div>
      <div class="d-flex align-items-center justify-content-between text-white" *ngIf="observables.memberCard.DiscountLevel > 0">
        <div class="font-size-14 text-start w-100">{{ 'barcode.general.discount' | translate }}</div>
        <div class="font-size-14 fw-bold text-end w-100">{{ observables.memberCard.DiscountLevel ?? 0 }}%</div>
      </div>
    </div>

    <!-- mobile navigation -->
    <div class="mobile-navigation-wrapper" *ngIf="showMobileNavigation">
      <div class="mobile-navigation d-flex flex-row align-items-center pb-2 mb-2" (scroll)="onNavScroll($event)">
        <div class="navigation" routerLink="/games">
          <span class="icons material-symbols-outlined bg-glass mb-1">sports_esports</span>
          <a class="text-white font-size-14">{{ 'member.card.games' | translate }}</a>
        </div>

        <div class="navigation" routerLink="/rewards">
          <span class="icons material-symbols-outlined bg-glass mb-1">redeem</span>
          <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
        </div>

        <div class="navigation" routerLink="/challenges">
          <span class="icons material-symbols-outlined bg-glass mb-1">emoji_events</span>
          <a class="text-white font-size-14">{{ 'member.card.challenges' | translate }}</a>
        </div>

        <div class="navigation" routerLink="/news">
          <span class="icons material-symbols-outlined bg-glass mb-1">newsmode</span>
          <a class="text-white font-size-14">{{ 'member.card.news' | translate }}</a>
        </div>

        <div class="navigation" routerLink="/earn">
          <span class="icons material-symbols-outlined bg-glass mb-1">money</span>
          <a class="text-white font-size-14">{{ 'member.card.earn' | translate }}</a>
        </div>

        <div class="navigation" routerLink="/ecash">
          <span class="icons material-symbols-outlined bg-glass mb-1">credit_card</span>
          <a class="text-white font-size-14">{{ 'member.card.ecash' | translate }}</a>
        </div>
      </div>

      <!-- Right shadow -->
      <div class="scroll-shadow" [class.hidden]="isNavAtEnd"></div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
